angular.module("digitalLeasing.module").component("rateAndFee", {
    templateUrl: "ng/components/digitalLeasing/financialData/rateAndFee/rateAndFee.view.html",
    bindings: {
        model: "=",
        onRateAndFeeChange: "&",
        onCalcolaTasso: "&",
        checkComponent: '&',
        canoneTassoCalled:'<',
        checkSpreadNetto:'<',
        snapshot:'<',
        canoneTassoRunning:'<',
        checkCalcCanoneTassoRun: "&",
        enableCanone:'<'
    },
    controllerAs: "rateAndFeeCtrl",
    controller: RateAndFeeController
});

function RateAndFeeController(
    $financialService,
    PianoFinanziario,
    $timeout,
    $rootScope
) {
    var self = this;

    self.$onInit = function () {
        if(!self.model.leasingData.preventivo.pianoFinanziario.tassiCalcolati.tassoOCanoneUtente){
        self.model.leasingData.preventivo.pianoFinanziario.tassiCalcolati.tassoOCanoneUtente = "";
        }else if(self.model.leasingData.preventivo.pianoFinanziario.tassiCalcolati.tassoOCanoneUtente == "C"){
            self.enableModify = true;
        }
        $timeout(function(){
            checkPage();
            controlloSpreadNetto();
        },5000) 
        
    };

    self.$onChanges = function(change){
        if(change.canoneTassoCalled && typeof change.canoneTassoCalled.currentValue!= 'undefined'){
            checkPage();
        }

        if(change.checkSpreadNetto && typeof change.checkSpreadNetto.currentValue != 'undefined'){
            controlloSpreadNetto();
        }

        if(change.canoneTassoRunning && typeof change.canoneTassoRunning.currentValue != 'undefined'){
            self.canoneTassoRunning = change.canoneTassoRunning.currentValue
        }

        if(change.enableCanone && typeof change.enableCanone.currentValue != 'undefined'){
            if(!self.enableModify && !change.enableCanone.currentValue){
                self.enableModify=true;
            }else{
                self.enableModify= change.enableCanone.currentValue;
            }
            
        }
    }

    self.handleRateFeeChange = function (property, value) {

        switch (property) {
            case 'canone':
                self.model.leasingData.preventivo.pianoFinanziario.tassiCalcolati.tassoOCanoneUtente = "C";
                if(self.model.leasingData.preventivo.pianoFinanziario.canone == value){
                    return;
                }else{
                    self.model.leasingData.preventivo.pianoFinanziario.canone = value;
                }

                if (value) {
                    calcolaTasso();
                }
                checkPage();
                break;

            case 'tasso':
                self.model.leasingData.preventivo.pianoFinanziario.tassiCalcolati.tassoOCanoneUtente = "L";
                self.onRateAndFeeChange();
                console.log("calcola Canone tasso rateAndFee")
                checkPage();
                break;
            case 'tassoNetto':
                self.model.leasingData.preventivo.pianoFinanziario.tassiCalcolati.tassoOCanoneUtente = "N";
                self.onRateAndFeeChange();
                console.log("calcola Canone tassoNetto rateAndFee")
                checkPage();
                break;

            default:
                checkPage();
                break;
        }

    };

    var calcolaTasso = function () {
        if(self.snaphot){
            return
        }
        self.model.leasingData.preventivo.assicurazioni = self.model.leasingData.preventivo.assicurazioni
            .filter(function (e) {
                return e != ""
            })
        var checkAssicurazioni = self.model.leasingData.preventivo.assicurazioni
            .some(function (element) {
                return element.polizze[0].premi.importoPremioAttivo == null ||
                    element.polizze[0].premi.importoPremioAttivo == "undefined"
            })
        if (!self.model.leasingData.preventivo ||
            !self.model.leasingData.preventivo.pianoFinanziario.durataMesi ||
            !self.model.leasingData.preventivo.pianoFinanziario.numeroRate ||
            self.model.leasingData.preventivo.pianoFinanziario.riscatto.importo == null ||
            self.model.leasingData.preventivo.pianoFinanziario.anticipo.importo == null ||
            self.model.leasingData.preventivo.pianoFinanziario.infoTassi.modalitaCalcoloTasso[0].tassoBase == null ||
            self.model.leasingData.preventivo.pianoFinanziario.infoTassi.modalitaCalcoloTasso[0].tassoTrasferimento == null ||
            self.model.leasingData.preventivo.pianoFinanziario.infoTassi.modalitaCalcoloTasso[0].description == null ||
            checkAssicurazioni ||
            (self.model.leasingData.preventivo.pianoFinanziario.provvigioni.digitate && self.model.leasingData.preventivo.pianoFinanziario.provvigioni.importo == null)) {
            return;
        }
        self.calcolaTassoisRunning = true;
        self.canoneTassoRunning = true;
        self.checkCalcCanoneTassoRun({value: true});
        checkPage();
        $financialService.calcolaTasso(self.model.leasingData.preventivo, self.model.financialVendor.reteVendita, self.model.financialVendor.mansioneAziendale, self.model.financialVendor.mansioni)
            .then(function (response) {
                self.calcolaTassoisRunning = false;
                self.canoneTassoRunning = false;
                self.checkCalcCanoneTassoRun({value: false});
                if (response.message) {
                    self.onCalcolaTasso({
                        response: response.pianoFinanziario
                    })
                    self.model.leasingData.preventivo.pianoFinanziario.tassiCalcolati.spreadLordo = null;
                    self.model.leasingData.preventivo.pianoFinanziario.tassiCalcolati.spreadNetto = null;
                    self.model.leasingData.preventivo.pianoFinanziario.tassiCalcolati.tassoMinimo = null;
                    self.model.leasingData.preventivo.pianoFinanziario.tassiCalcolati.tassoEffettivo = null;
                    self.model.leasingData.preventivo.pianoFinanziario.tassiCalcolati.tassoLeasing = null;

                    return;
                }
                self.onCalcolaTasso({
                    response: response.pianoFinanziario
                })
                self.model.leasingData.preventivo.pianoFinanziario = PianoFinanziario.build(response.pianoFinanziario);
                self.model.leasingData.preventivo.validations.spreadNetto= response.validations.spreadNetto;
                self.model.leasingData.preventivo.validations.spreadNettoReale= response.validations.spreadNettoReale;
                controlloSpreadNetto();
                checkPage();
                
            })
            .catch(function (error) {
                self.checkCalcCanoneTassoRun({value: false});
                console.log(error);
                self.calcolaTassoisRunning = false;
                self.canoneTassoRunning = false;
                checkPage();

            })
    }
    self.enabledDisabledFee = function () {
        self.enableModify = !self.enableModify;
        $timeout(function(){
            $("#canone").prop( "disabled", !self.enableModify);
        },500)
    }

    var calcolaCanone = function () {
        if(self.snaphot){
            return
        }
        if (!self.model.leasingData.preventivo) {
            return
        } 
        self.model.leasingData.preventivo.assicurazioni = self.model.leasingData.preventivo.assicurazioni
            .filter(function (e) {
                return e != ""
            })
        var checkAssicurazioni = self.model.leasingData.preventivo.assicurazioni
            .some(function (element) {
                return element.polizze[0].premi.importoPremioAttivo == null ||
                    element.polizze[0].premi.importoPremioAttivo == "undefined"
            })
        if (!self.model.leasingData.preventivo ||
            !self.model.leasingData.preventivo.pianoFinanziario.durataMesi ||
            !self.model.leasingData.preventivo.pianoFinanziario.numeroRate ||
            self.model.leasingData.preventivo.pianoFinanziario.riscatto.importo == null ||
            self.model.leasingData.preventivo.pianoFinanziario.anticipo.importo == null ||
            self.model.leasingData.preventivo.pianoFinanziario.infoTassi.modalitaCalcoloTasso[0].tassoBase == null ||
            self.model.leasingData.preventivo.pianoFinanziario.infoTassi.modalitaCalcoloTasso[0].tassoTrasferimento == null ||
            self.model.leasingData.preventivo.pianoFinanziario.infoTassi.modalitaCalcoloTasso[0].description == null ||
            checkAssicurazioni ||
            (self.model.leasingData.preventivo.pianoFinanziario.provvigioni.digitate && self.model.leasingData.preventivo.pianoFinanziario.provvigioni.importo == null)) {
            return;
        }
        self.calcolaCanoneIsRunning= true;
        self.canoneTassoRunning = true;
        self.checkCalcCanoneTassoRun({value: true});
        checkPage();
        $financialService.calcolaCanone(self.model.leasingData.preventivo, self.model.financialVendor.reteVendita, self.model.financialVendor.mansioneAziendale, self.model.financialVendor.mansioni)
            .then(function (response) {
                self.calcolaCanoneIsRunning= false;
                self.canoneTassoRunning = false;
                self.checkCalcCanoneTassoRun({value: false});
                if (response.pianoFinanziario.canone) {
                    self.model.leasingData.preventivo.pianoFinanziario = PianoFinanziario.build(response.pianoFinanziario);
                    self.model.leasingData.preventivo.validations.spreadNetto= response.validations.spreadNetto;
                    self.model.leasingData.preventivo.validations.spreadNettoReale= response.validations.spreadNettoReale;
                    self.onCalcolaTasso({
                        response: response.pianoFinanziario
                    });
                }
                controlloSpreadNetto();
                checkPage();
                

            })
            .catch(function (error) {
                self.checkCalcCanoneTassoRun({value: false});
                console.log(error);
                self.calcolaCanoneIsRunning= false;
                self.canoneTassoRunning = false;
                checkPage();

            })
    }
    self.resetCanone = function () {
        self.model.leasingData.preventivo.pianoFinanziario.tassiCalcolati.tassoOCanoneUtente = "";
        calcolaCanone();
    }

    var checkPage = function () {

        var test = !!self.model.leasingData.preventivo.pianoFinanziario.canone &&
            !!self.model.leasingData.preventivo.pianoFinanziario.tassiCalcolati.tassoLordo &&
            !!self.model.leasingData.preventivo.pianoFinanziario.tassiCalcolati.tassoNetto &&
            !self.enableTooltipLocked &&
            !self.calcolaCanoneIsRunning &&
            !self.calcolaTassoisRunning

        if (test) {
            self.checkComponent({
                value: true
            })
        } else {
            self.checkComponent({
                value: false
            })
        }

    }

    var controlloSpreadNetto = function(){
        if(self.model.leasingData.preventivo.validations.spreadNetto && 
        self.model.leasingData.preventivo.validations.spreadNetto.minimo &&
        self.model.leasingData.preventivo.pianoFinanziario.tassiCalcolati.spreadNetto < self.model.leasingData.preventivo.validations.spreadNetto.minimo.valore){
            self.enableTooltip = true;
            self.enableTooltipLocked= false;
            self.testoSpreadNsil="Il piano di ammortamento calcolato determina un valore dello spread netto nsil non ammesso.<br/>Min: "+self.model.leasingData.preventivo.validations.spreadNetto.minimo.valore+";"
        }else{
            self.enableTooltip= false;
        }

        if(self.model.leasingData.preventivo.validations.spreadNettoReale &&
        self.model.leasingData.preventivo.validations.spreadNettoReale.minimo &&
        self.model.leasingData.preventivo.pianoFinanziario.tassiCalcolati.spreadNettoReale < self.model.leasingData.preventivo.validations.spreadNettoReale.minimo.valore){
            self.enableTooltipSpreaNet = true;
            self.testoSpread="Il piano di ammortamento calcolato determina un valore dello spread netto non ammesso.<br/>Min: "+self.model.leasingData.preventivo.validations.spreadNettoReale.minimo.valore+";"
        }else{
            self.enableTooltipSpreaNet= false;
        }

        if(self.model.leasingData.preventivo.pianoFinanziario.tassiCalcolati.spreadNetto < self.model.leasingData.preventivo.validations.spreadNetto.minimoBloccante.valore ||
            self.model.leasingData.preventivo.pianoFinanziario.tassiCalcolati.spreadNetto > self.model.leasingData.preventivo.validations.spreadNetto.massimoBloccante.valore
        ){
            self.enableTooltipLocked = true;
            self.enableTooltip= false;
            self.testoSpreadNsil="Il piano di ammortamento calcolato determina un valore dello spread netto nsil non consentito.<br/>Min: "+self.model.leasingData.preventivo.validations.spreadNetto.minimoBloccante.valore+";<br/>Max: "+self.model.leasingData.preventivo.validations.spreadNetto.massimoBloccante.valore+";"
        }else{
            self.enableTooltipLocked= false;
        }
        checkPage();
    }
}